import React, {Dispatch, useEffect, useState} from 'react';
import styled from 'styled-components';
import { NavigationItem } from '../../../types/navigationItem';
import { VLink } from '../../other/vLink';
import { Link } from 'gatsby';

const StyledLink = styled(VLink)`
  &::after {
    content: "";
    position: absolute;
    bottom: -2px;
    left: 0;
    right: 0;
    height: 3px;
    background-color: #46ff46;
    transform: scaleX(0);
    transition: all .3s ease-in-out 0s;
  }

  &.has-active-child {
    &::after {
      content: "";
      position: absolute;
      bottom: -2px;
      left: 0;
      right: 0;
      height: 3px;
      background-color: #46ff46;
      transition: all .3s ease-in-out 0s;
      transform: scaleX(1);
    }
  }
`;

const MenuContainer = styled.div<{open: boolean}>(({open}) => `
  top: 53px;
  background-color: #f3eee2;
  border: 1px solid #5b5954;
  min-width: 100%;
  width: auto;
  white-space: nowrap;
  opacity: 0;
  visibility: hidden;
  transform: translate(0, 10px);
  transition: opacity 200ms ease-in, transform 200ms ease-in, visibility 200ms ease-in;

  ${open && `
    opacity: 1;
    visibility: visible;
    transform: translate(0, 0);
  `}
`);

const DualContainer = styled.div<{open: boolean}>(({open}) => `
  top: 53px;
  background-color: #f3eee2;
  border: 1px solid #5b5954;
  min-width: 100%;
  width: auto;
  white-space: nowrap;
  opacity: 0;
  visibility: hidden;
  transform: translate(0, 10px);
  transition: opacity 200ms ease-in, transform 200ms ease-in, visibility 200ms ease-in;

  ${open && `
    opacity: 1;
    visibility: visible;
    transform: translate(0, 0);
  `}
`);

export const MainLink = ({ navigationItem }: { navigationItem: NavigationItem }) => {

  const [menuOpen, setMenuOpen] = useState(false);
  const hasChildren = navigationItem.sections && navigationItem.sections.length > 0;

  const columns = navigationItem.sections?.length;

  function handleMouseEnter() {
    if (hasChildren) {
      setMenuOpen(true);
    }
  }

  function handleMouseLeave() {
    if (hasChildren) {
      setMenuOpen(false);
    }
  }

  return (
    <li className={`${columns === 1 ? `relative`  : `` } inline-block`} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
      <StyledLink
        className={`text-black cursor-pointer uppercase text-lg ml-8 relative' : ''}`}
        to={navigationItem.titleLink}
      >
        {navigationItem.title}
      </StyledLink>

      {hasChildren &&
        (
          <Menu
            open={menuOpen}
            navigationItem={navigationItem}
            columns={columns}
          />
        )
      }
    </li>
  );
};

interface MenuProps {
  open: boolean;
  columns: number;
  navigationItem: NavigationItem;
}

const Menu = ({ open, columns, navigationItem }: MenuProps) => {

  const { sections } = navigationItem;
  let additionalClasses = ''; if (columns === 4) {
    additionalClasses = 'w-screen left-0 mt-6 flex justify-evenly px-12';
  }

  return (
    <MenuContainer open={open} className={`absolute p-8 ${additionalClasses}`}>
      {sections.map((section) => {

        return (
          <div key={section.key} className={`w-1/${columns}`}>
            {section.sectionTitle && <p className="font-bold uppercase">{section.sectionTitle}</p>}

            {section.sectionLinks.map((sectionLink, sectionLinkIndex) => {

              if (sectionLink.sectionLinkType === 'Feature Link') {

                return (
                  <div key={sectionLinkIndex}>
                    <p className="font-bold uppercase">{sectionLink.sectionLinkTitle}</p>
                    <Link className="block underline uppercase"  key={sectionLink.key} to={sectionLink.sectionLinkSlug}>

                      <div
                        className="w-full h-24 mb-2 bg-center bg-cover"
                        style={{
                          backgroundImage: `url(${sectionLink.sectionLinkFeatureImage.url})`,
                          }}
                      />
                    </Link>
                    <Link className="block underline uppercase hover:opacity-60"  key={sectionLink.key} to={sectionLink.sectionLinkSlug}>
                      {sectionLink.sectionLinkCtaLinkText}
                    </Link>
                  </div>
                );

              }

              return (
                <Link className="block hover:opacity-60"  key={sectionLink.key} to={sectionLink.sectionLinkSlug}>
                  {sectionLink.sectionLinkTitle}
                </Link>
              );
            })}

          </div>
        );

      })}
    </MenuContainer>
  );
};
